import { instance } from "libs/api";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestCreateInventoryBoxQr =
  async (): Promise<InventoryBoxQrsListItem> => {
    return await instance.post(ApiRoutesInventory.CreateInventoryBox);
  };
